export const FILTER_TAG_QUERY = 'category';
